import { useQuery } from '@tanstack/react-query';
import { GetGpQrEntity, UserWalletTransactionService } from 'services/openapi';

import { PointQueryKeys } from './constants';
import { isEmpty } from 'lodash';

type GetGpQrRequest = {
  amount: string;
};

export const useGetPointQRGalaxyPayQuery = (variables: GetGpQrRequest) => {
  const queryKey = [PointQueryKeys.GET_QRCODE_GALAXY_PAY, variables];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetGpQrEntity, Error>({
    queryKey,
    queryFn: () =>
      UserWalletTransactionService.transactionControllerGetGalaxyPayQr(
        variables.amount,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled:
      !isEmpty(variables) &&
      variables.amount !== '0' &&
      variables.amount !== '',
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data: data,
    isError,
    queryKey,
    refetch,
  };
};
